// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Df13","newExpiryDate":"styles_newExpiryDate__1NwtI","footer":"styles_footer__1d9H3"};